import React, {Fragment} from 'react';
import { compose} from "redux";
import { connect as reduxConnect } from "react-redux";
import { connect, replace,FastField } from 'formik';
import styled from 'styled-components';
import numberFormatter from 'utils/numberFormatter';
import Card from '@material-ui/core/Card';
import {
  Add,
  Edit as EditIcon, 
  Delete as TrashcanIcon, 
} from "@material-ui/icons";
import {getHedgesOfLoan, updateHedgeDetails, setPrefHedgeOfLoan, deleteHedge} from "store/state/hedge";
import hedgeStatus from "constants/hedgeStatus";
import maturityTypes from "constants/maturityTypes";
import hedgeTypes from 'constants/hedgeTypes';
import {PrimaryButton, SecondaryButton} from 'components/Global/Buttons'
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import WatchHedgeStubModal from "./WatchHedgeStubModal";

  const SectionContainer = styled.div`
    width: 100%;
    margin-top: 30px;
  `;

  const TitleSeciton = styled.div`
    width: 500px;
    border-bottom: 1px solid #ccc;
    font-size: 22px;
    font-weight: bold;
    color: #2b5979;
  `;

  const HedgeCard = styled(Card)`
    &&{
      background-color: #fefefe;
      padding: 10px;
      width: 340px
      height: 230px;
      display: inline-block;
      border: 1px solid #ccc;
      margin-top: 20px;
      margin-right: 50px;
      box-shadow: 1px 1px 5px grey;
      borderRadius: 1px;
    }
  `;

    const CenterPieceSection = styled.div`
      height: 50px;
      text-align: center;
      color: black;
      margin-top: 20px;
    `;

    const SecondaryInfoItem = styled.div`
      width: 33%;
      text-align: center;
      color: black;
      display: inline-block;
    `;

    const SecondaryInfoContainer = styled.div`
      border-bottom: 1px solid #ccc;
      margin-top: 25px;
      height: 65px;
    `;

    const NoHedgesBar = styled.div`
      background-color: #eeeeee;
      border-radius: 5px;
      height: 40px;
      width: 80%;
      margin-top: 20px;
      padding: 10px;
      color: #999999;
    `;

  const LOANBOSS_BLUE = "#2196f3";
  const DARK_BLUE = "#4b79af";


class LinkedHedgesSection extends React.Component {

  componentDidMount () {
    const loanId = this.getLoanIdFromUrl();
    this.props.getHedgesOfLoan({loanId});
    this.setState({prefHedgeId: this.props.loan.details.prefHedgeId})
  }

  getLoanIdFromUrl = () => {
    return this.props.match.params.loanId;
  }

  componentDidUpdate(prevProps, prevState){
    if(!this.state.received && prevState.received) return null;
    const props = this.props;
    if(props.hedges && props.hedges.length > 0 && `${window.location.href}`.includes(`${props.hedgesOfLoanId}`) && !this.state.received){
      this.setState({
        received: true, 
        hedges: props.hedges,
      });
    }
  }

  state = {
    hedges: [],
    prefHedgeId: null,
    received: false,
    modalOpen: false,
    currentlyEditingHedge: null,
    numNewHedges : 0,
    confirmDeletModalOpen : false,
    hedgeToDelete: null,
  }

  getCenterPieceForHedge(hedge){
    switch(hedge.hedgeType.value.toLowerCase()){
      case "cap":
        return (
          <CenterPieceSection>
            <span style={{fontSize:"40px"}}>{`${numberFormatter.maskCurrency(hedge.marketCost , "-", true)}`}</span>
            <br/>
            <span style={{color:DARK_BLUE, fontSize: "15px"}}>Market Cost</span>
          </CenterPieceSection>
        );
      
      case "swap":
        return(
          <CenterPieceSection>
            <span style={{fontSize:"40px"}}>{`${hedge.marketRate ? `${hedge.marketRate.toFixed(2)}%` : "-"}`}</span>
            <br/>
            <span style={{color:DARK_BLUE, fontSize: "15px"}}>Swap Rate</span>
          </CenterPieceSection>
        )
    }
  }

  renderSecondaryInfoSectionForHedge = (hedge) => {
    switch(hedge.hedgeType.value.toLowerCase()){
      case "cap":
        return(
          <SecondaryInfoContainer>
            <SecondaryInfoItem>
              <span style={{fontSize: "20px", fontWeight:"normal"}}>{`${hedge.notional ? `${numberFormatter.maskCurrency(hedge.notional, "-", true)}` : "-"}`}</span>
              <br/>
              <span style={{fontSize: "15px", color:DARK_BLUE}}>Notional</span>  
            </SecondaryInfoItem>
            <SecondaryInfoItem style={{borderLeft: "1px solid #ccc", borderRight: "1px solid #ccc"}}>
              <span style={{fontSize:"20px", fontWeight:"normal"}}>{`${hedge.strike ? `${hedge.strike.toFixed(2)}%` : "-"}`}</span>
              <br/>
              <span style={{fontSize: "15px", color:DARK_BLUE}}>Strike</span>  
            </SecondaryInfoItem>
            <SecondaryInfoItem>
              <span style={{fontSize: "20px", fontWeight:"normal"}}>{`${hedge.term ? `${hedge.term} Months` : "-"}`}</span>
              <br/>
              <span style={{fontSize: "15px", color:DARK_BLUE}}>Term</span>
            </SecondaryInfoItem>
          </SecondaryInfoContainer>
        );
      
      case "swap":
        return (
          <SecondaryInfoContainer >
            <SecondaryInfoItem>
              <span style={{fontSize: "20px", fontWeight:"normal"}}>{`${hedge.notional ? `${numberFormatter.maskCurrency(hedge.notional, "-", true)}` : "-"}`}</span>
              <br/>
              <span style={{fontSize: "15px", color:DARK_BLUE}}>Notional</span>  
            </SecondaryInfoItem>
            <SecondaryInfoItem style={{borderLeft: "1px solid #ccc", borderRight: "1px solid #ccc"}}>
              <span style={{fontSize:"20px", fontWeight:"normal"}}>{`${hedge.spread ? `${hedge.spread.toFixed(2)}%` : "-"}`}</span>
              <br/>
              <span style={{fontSize: "15px", color:DARK_BLUE}}>Spread</span>  
            </SecondaryInfoItem>
            <SecondaryInfoItem>
              <span style={{fontSize: "20px", fontWeight:"normal"}}>{`${hedge.term ? `${hedge.term} Months` : "-"}`}</span>
              <br/>
              <span style={{fontSize: "15px", color:DARK_BLUE}}>Term</span>
            </SecondaryInfoItem>
          </SecondaryInfoContainer>
        );
    }
  }

  renderControlSectionForHedge = hedge => {
    return (
      <div style={{color:LOANBOSS_BLUE, verticalAlign: "middle", borderRadius: "3px"}}>
        {this.renderPrefButton(hedge)}
        <div style={{textAlign: "right", display:"inline-block", width:"50%", verticalAlign: "middle", fontSize:"30px"}}>
          <EditIcon style={{marginRight:"15px", cursor:"pointer"}} onClick={()=>this.editHedge(hedge)} />
          <TrashcanIcon style={{cursor: "pointer"}} onClick={()=>{
            this.setState({
              confirmDeletModalOpen: true,
              hedgeToDelete: hedge,
            })
          }}/>
        </div>
      </div>
    )
  }

  renderPrefButton = hedge => {
    if(hedge.id != this.state.prefHedgeId){
      return (
        <div 
          style={{ width:"150px", color: LOANBOSS_BLUE, fontSize: "16px", cursor: "pointer", display: "inline-block", height:"100%", padding:"8px", margin: "2px", marginTop: "5px"}}
          onClick = {()=>{this.setPrefHedge(hedge.id)}}
        >
          Set As Preference
        </div>
      );
    } else {
      return (
        <div
        style={{
          width: "120px",
          marginRight: "30px",
          color: "#ffffff",
          backgroundColor: LOANBOSS_BLUE,
          fontSize: "16px", cursor: "pointer",
          display: "inline-block", height:"100%",
          padding:"8px",
          margin:"2px",
          marginTop: "5px",
          borderRadius:"3px"
        }}
        onClick = {()=>{this.setPrefHedge(null)}}
        >
          Preferred Hedge
        </div>
      )
    }
  }

  renderCards = () =>{
    const hedges = this.state.hedges;
    if(!hedges || hedges.length === 0){
      return (
        <NoHedgesBar>
          No Hedges
        </NoHedgesBar>
      );
    }
    const out = [];
    hedges.forEach(hedge => {
      if(!hedge.hedgeType || !hedge.hedgeType.value) return null;
      out.push(
        <HedgeCard>
          <div style={{height: "100%", color: DARK_BLUE, fontWeight: "bold"}}>
            {`${hedge.hedgeType.value}`}
            {this.getCenterPieceForHedge(hedge)}
            {this.renderSecondaryInfoSectionForHedge(hedge)}
            {this.renderControlSectionForHedge(hedge)}
          </div>
        </HedgeCard>
      );
    });
    return out;
  }

  setPrefHedge = hedgeId => {
    this.setState({prefHedgeId : hedgeId});
    this.props.setPrefHedgeOfLoan({loanId: this.getLoanIdFromUrl(), hedgeId})
  }

  deleteHedge = hedge => {
    this.setState({
      hedges: this.state.hedges.filter(x=>x.id!==hedge.id),
    })
    this.props.deleteHedge({hedgeId: hedge.id});
  }

  editHedge = hedge => {
    this.setState({
      modalOpen: true,
      currentlyEditingHedge: hedge,
    })
  }

  openHedgeModal = () => {
    this.setState({
      modalOpen: true,
    })
  }

  closeHedgeModal = () => {
    this.setState({
      modalOpen : false
    })
  }

  updateHedge = ({hedgeType, strike, swapRate, notional, term, spread, creditCharge, ratingsTriggerId}) => {
    const currentlyEditingHedge = this.state.currentlyEditingHedge;
    let upsertedHedge = currentlyEditingHedge || {};
    if(currentlyEditingHedge){
      upsertedHedge.strike = strike;
      upsertedHedge.marketRate = swapRate;
      upsertedHedge.notional = notional;
      upsertedHedge.term = term;
      upsertedHedge.hedgeType = hedgeType;
      upsertedHedge.spread = spread;
      upsertedHedge.creditCharge = creditCharge;
      upsertedHedge.ratingsTriggerId = ratingsTriggerId;
      let newHedges = this.state.hedges.filter(x=>x.id!=upsertedHedge.id);
      newHedges.push(upsertedHedge);
      this.setState(newHedges);
    }else{
      upsertedHedge.id = null;
      upsertedHedge.strike = strike;
      upsertedHedge.marketRate = swapRate;
      upsertedHedge.notional = notional;
      upsertedHedge.term = term;
      upsertedHedge.hedgeType = hedgeType;
      upsertedHedge.spread = spread;
      upsertedHedge.creditCharge = creditCharge;
      upsertedHedge.ratingsTriggerId = ratingsTriggerId;
      let newHedges = this.state.hedges;
      newHedges.push(upsertedHedge);
      this.setState({hedges: newHedges});
    }

    let hedgeDetailsRequest = {};
    hedgeDetailsRequest.loanId = this.getLoanIdFromUrl();
    hedgeDetailsRequest.isNew= !upsertedHedge.id;
    hedgeDetailsRequest.id = upsertedHedge.id || null;
    hedgeDetailsRequest.hedge = {...upsertedHedge};
    if(hedgeDetailsRequest.hedge.creditCharge) hedgeDetailsRequest.hedge.creditCharge /= 10000;
    if(hedgeDetailsRequest.hedge.strike) hedgeDetailsRequest.hedge.strike = (hedgeDetailsRequest.hedge.strike/=100).toFixed(4);
    if(hedgeDetailsRequest.hedge.spread) hedgeDetailsRequest.hedge.spread = (hedgeDetailsRequest.hedge.spread/=100).toFixed(4);
    hedgeDetailsRequest.hedge.loanId = this.getLoanIdFromUrl();
    hedgeDetailsRequest.hedge.dealId = this.props.dealId;
    hedgeDetailsRequest.hedge.hedgeStatusId = hedgeStatus.WATCH;
    hedgeDetailsRequest.hedge.indexId = this.props.loan.details.indexId;
    hedgeDetailsRequest.hedge.daycountId = this.props.loan.details.daycountId;
    hedgeDetailsRequest.hedge.effectiveDate = this.props.deal.targetedClosing;
    let terminationDate = this.props.deal.targetedClosing ? new Date(this.props.deal.targetedClosing.split("T")[0]) : new Date();
    let monthsToAdd = this.props.loan.details.loanTermMonths;
    while(monthsToAdd > 0){
      monthsToAdd--;
      if(terminationDate.getMonth() === 11){
        terminationDate.setMonth(0);
        terminationDate.setFullYear(terminationDate.getFullYear() + 1);
      }else{
        terminationDate.setMonth(terminationDate.getMonth() + 1);
      }
    }
    hedgeDetailsRequest.hedge.terminationDate = terminationDate;
    hedgeDetailsRequest.hedge.maturityTypeId = maturityTypes.ROLLING_MATURITY;
    hedgeDetailsRequest.hedge.isLenderRequired = false;
    if(upsertedHedge.hedgeType && upsertedHedge.hedgeType.value.toLowerCase()==="cap"){
      hedgeDetailsRequest.hedge.hedgeTypeId= hedgeTypes.CAP;
    }
    if(upsertedHedge.hedgeType && upsertedHedge.hedgeType.value.toLowerCase()==="swap"){
      hedgeDetailsRequest.hedge.hedgeTypeId= hedgeTypes.SWAP;
    }
    this.props.updateHedgeDetails(hedgeDetailsRequest);
    setTimeout(()=>{
      this.setState({received: false});
      this.props.getHedgesOfLoan({loanId: this.getLoanIdFromUrl()});
    }, 1500);
  }

  renderConfirmDeleteModal = () => {
    return (
      <SimpleConfirmDialog 
        title = {"Confirm Delete"}
        message = {"Are you sure you want to delete this hedge?"}
        modalOpen = {this.state.confirmDeletModalOpen}
        handleNo = {()=>this.setState({confirmDeletModalOpen: false})}
        handleYes = {() => {
          this.deleteHedge(this.state.hedgeToDelete);
          this.setState({confirmDeletModalOpen: false});
        }}
        noText = {"Cancel"}
        yesText = {'Confirm'}
      />
    );
  }


  render() {
    return (
      <SectionContainer>
        {this.renderConfirmDeleteModal()}
        <TitleSeciton>
          Hedge
          <SecondaryButton onClick={() => {
              this.setState({
                currentlyEditingHedge: null,
                modalOpen: true,
              });
            }
          }>
            <Add/> New Hedge
          </SecondaryButton>
          </TitleSeciton>
        {this.renderCards()}
        <WatchHedgeStubModal 
          modalOpen = {this.state.modalOpen} 
          handleClose = {this.closeHedgeModal}
          handleAccept = {(payload)=>{this.updateHedge(payload);this.closeHedgeModal()}}
          hedge = {this.state.currentlyEditingHedge}
          defaultNotional = {this.props.loan.details.amount}
        />
      </SectionContainer>
    )
  }

}

const mapStateToProps = ({ hedge, loanDetails }) => ({
  hedges: hedge.hedgesOfLoan,
  hedgesOfLoanId: hedge.hedgesOfLoanId,
  loan: loanDetails.loanDetails,
  });
  
  export default compose(  
    connect,
    reduxConnect(
      mapStateToProps,
          { 
        getHedgesOfLoan,        
        updateHedgeDetails,
        setPrefHedgeOfLoan,
        deleteHedge,
      } 
    )    
  )(LinkedHedgesSection);